export default {
  namespaced: true,
  state: {
    selectedUsers: [],
  },
  mutations: {
    //更新选中审批人
    updateSelectedUsers(state, data) {
      console.log('updateSelectedUsers-->', data);
      state.selectedUsers = data
    },
  },
  actions: {
    updateSelectedUsers({ commit }, data) {
      commit('updateSelectedUsers', data)
    },
  },
  getters: {

  },
}



// WEBPACK FOOTER //
// ./src/store/modules/flow/index.js